/**
 * Helper method for filterOutUnorderedListTags, filters out the content between <li> tags and appends a <br> tag. Also prepends a bullet point (&#8226;)
 * @param {*} text Input text including any HTML
 * @returns
 */
export const disclosureTextListToLineBreaks = text => {
  const listItems = text.match(/<li>(.*?)<\/li>/g).map(item => {
    return item.replace(/<\/?li>/g, '');
  });
  let resultString = ``;
  listItems.forEach(item => {
    resultString += `  &#8226; ${item}<br>`;
  });

  return `<br>${resultString}`;
};

/**
 * Filters out any <ul> tags in a disclosure, if any, and converts them to <br> tags so they won't create new cells in a row.
 * @param {*} text Input text including any HTML
 * @returns
 */
export const filterOutUnorderedListTags = text => {
  let listText = text.match(/(<ul>[\s\S]*?<\/ul>)/g);
  listText = listText.map(val => {
    return disclosureTextListToLineBreaks(val);
  });
  listText.forEach(val => {
    text = text.replace(/(<ul>[\s\S]*?<\/ul>)/, val);
  });
  return text;
};
